var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImage1 = function SvgImage1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 600 800"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1b1464",
    d: "M0 0h600v800H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M589.06 476.68H484.11V452.3H371.9v-18.21h4l-3.21-9.4h-56.88l-3.21 9.4h4v18.21h-40.18l-8.14 56.85h-16L243.79 280h3.86v-11.9h-4.3l-.45-12.1h1.71v-3.13h-3.39v-21h3.39v-3.13h-3.39a16.32 16.32 0 0 0-15.7-16.3V201.3h-1.26v11.19a16.31 16.31 0 0 0-15.7 16.3h-3.4v3.13h3.4v21h-3.4V256h1.72l-.45 12.06h-4.3V280H206l-8.5 229.15H89.88L71.54 579.7H10V790h580V592.32h.94Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fcb900",
    d: "m589.49 289.01-348.27-36.1v-20.99l349.72-50.98zM10 273.49l198.56-20.58v-20.99L10 202.97zM355.29 502.42h8.77v15.9h-8.77zM376.9 502.42h8.77v15.9h-8.77zM333.67 502.42h8.77v15.9h-8.77zM312.06 502.42h8.77v15.9h-8.77zM398.52 502.42h8.77v15.9h-8.77zM420.13 502.42h8.77v15.9h-8.77zM441.75 502.42h8.77v15.9h-8.77zM322.78 438.37h4.76v6.61h-4.76zM335.47 438.37h4.76v6.61h-4.76zM348.17 438.37h4.76v6.61h-4.76zM360.86 438.37h4.76v6.61h-4.76zM221.6 313.21h6.58v14.88h-6.58zM221.6 353.62h6.58v14.88h-6.58zM221.6 394.03h6.58v14.88h-6.58zM221.6 434.44h6.58v14.88h-6.58z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3d3d3",
    d: "M580 780V20l20-20v800z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M0 800V0l20 20v760z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#a5a5a5",
    d: "M580 20H20L0 0h600zM580 415H20L0 395h600z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#b5b5b5",
    d: "M600 800H0l20-20h560zM600 405H0l20-20h560z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#d3d3d3",
    d: "M285 385V20l20-20v405z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#8c8c8c",
    d: "M315 20v365l-20 20V0z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M305 0H0v800h600V0Zm285 10v385H305V10ZM10 10h285v385H10Zm0 780V405h580v385Z"
  })));
};
export default SvgImage1;